import React, { useState } from "react";
import { useNavigate } from "react-router-dom"
import * as AppFunc from "../lib/AppFunctions";
import "./Menu.css";
import APP_CONSTANTS from "../appConstants";

const Menu = () => { 
    const navigate = useNavigate();
    const activeUserRole = localStorage.getItem("user_role");
    const activeUser = JSON.parse(localStorage.getItem("user"));
    const notificationsCount = useState(0);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const handleLogout = () => {
      navigate("/")
      localStorage.removeItem("jwt-access-token");
      localStorage.removeItem("user");
      localStorage.removeItem("user_role");
    }

    const toggleSidebar = () => {
      setIsSidebarOpen(!isSidebarOpen);
    }

    const closeSidebar = () => {
      setIsSidebarOpen(false);
    }

    const handleMenuClick = (path) => {
      navigate(path);
      closeSidebar();
    }

return(
    <>
        {/* Navigation Icons - Menu and Notifications on same line */}
        <div className="navbar-nav me-auto mb-2 mb-lg-0 float-right">
          <div className="nav-icons-container">
            {AppFunc.hasMenuAccess(activeUserRole) && (
              <button 
                className="nav-link main_li sidebar-toggle-btn" 
                onClick={toggleSidebar}
              >
                <i className="bi bi-list fs-4"></i>
              </button>
            )}
            
            <div className="nav-item dropdown ms-2 me-2">
              <a className="nav-link" href="#" id="navbarDropdownuser" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                <i className="bi bi-person-circle"></i>
                
              </a>
              
              <ul className="dropdown-menu" aria-labelledby="navbarDropdownuser">
                <li><a className="dropdown-item" href="#">{activeUser.first_name} {activeUser.last_name}</a></li>
                <li><a className="dropdown-item" href="#">Role: {activeUserRole}</a></li>
                <li> 
                  <a className="dropdown-item"
                    onClick={handleLogout}
                    type="submit"
                  >
                    <i className="bi bi-box-arrow-right"> Logout</i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Overlay */}
        {isSidebarOpen && (
          <div 
            className="sidebar-overlay" 
            onClick={closeSidebar}
          ></div>
        )}

        {/* Sidebar */}
        <div className={`sidebar ${isSidebarOpen ? 'sidebar-open' : ''}`}>
          {/* Sidebar Header with Role Details */}
          <div className="sidebar-header">
            <button 
              className="sidebar-close-btn"
              onClick={closeSidebar}
            >
              ×
            </button>
          </div>

          {/* Sidebar Menu Items */}
          <div className="sidebar-menu">
            {AppFunc.hasEmployeeAccess(activeUserRole) && (
              <div className="sidebar-item" onClick={() => handleMenuClick('/employees')}>
                <i className="bi bi-people-fill me-2"></i>
                Resource List
              </div>
            )}
            
            {AppFunc.hasProjectAccess(activeUserRole) && (
              <div className="sidebar-item" onClick={() => handleMenuClick('/projects')}>
                <i className="bi bi-folder-fill me-2"></i>
                Projects
              </div>
            )}
            
            {AppFunc.hasClientAccess(activeUserRole) && (
              <div className="sidebar-item" onClick={() => handleMenuClick('/clients')}>
                <i className="bi bi-building-fill me-2"></i>
                Clients
              </div>
            )}
            
            {AppFunc.hasLineOfBusinessAccess(activeUserRole) && (
              <div className="sidebar-item" onClick={() => handleMenuClick('/lineOfBusiness')}>
                <i className="bi bi-briefcase-fill me-2"></i>
                Line of Business
              </div>
            )}
            
            {AppFunc.hasServiceLineAccess(activeUserRole) && (
              <div className="sidebar-item" onClick={() => handleMenuClick('/serviceLine')}>
                <i className="bi bi-diagram-2-fill me-2"></i>
                Service Lines
              </div>
            )}
            
            {AppFunc.hasCapabilityAreaAccess(activeUserRole) && (
              <div className="sidebar-item" onClick={() => handleMenuClick('/capabilityArea')}>
                <i className="bi bi-gear-fill me-2"></i>
                Capability Areas
              </div>
            )}
            
            {AppFunc.hasWorkRequestAccess(activeUserRole) && (
              <div className="sidebar-item" onClick={() => handleMenuClick('/workRequest')}>
                <i className="bi bi-clipboard-data-fill me-2"></i>
                Work Requests
              </div>
            )}
            
            {activeUserRole === APP_CONSTANTS.USER_ROLES.OFF_SHORE_LEAD && (
              <div className="sidebar-item" onClick={() => handleMenuClick('/offshoreLeadWorkRequests')}>
                <i className="bi bi-clipboard-check-fill me-2"></i>
                My Assigned Requests
              </div>
            )}
            
            {activeUserRole === APP_CONSTANTS.USER_ROLES.OFF_SHORE_LEAD && (
              <div className="sidebar-item" onClick={() => handleMenuClick('/offshoreTimesheetEntries')}>
                <i className="bi bi-calendar-check-fill me-2"></i>
                Timesheet Entries
              </div>
            )}
            
            {AppFunc.hasAllocationAccess(activeUserRole) && (
              <div className="sidebar-item" onClick={() => handleMenuClick('/empProjList')}>
                <i className="bi bi-diagram-3-fill me-2"></i>
                Allocations
              </div>
            )}
            
            {AppFunc.hasUtilizationAccess(activeUserRole) && (
              <div className="sidebar-item" onClick={() => handleMenuClick('/empUtiliList')}>
                <i className="bi bi-graph-up me-2"></i>
                Utilization
              </div>
            )}
            
            {AppFunc.hasCategoriesAccess(activeUserRole) && (
              <div className="sidebar-item" onClick={() => handleMenuClick('/categoryList')}>
                <i className="bi bi-tags-fill me-2"></i>
                Categories
              </div>
            )}
            
            {AppFunc.hasUserAccess(activeUserRole) && (
              <div className="sidebar-item" onClick={() => handleMenuClick('/userList')}>
                <i className="bi bi-person-fill me-2"></i>
                Users
              </div>
            )}
            
            {AppFunc.hasUserRoleAccess(activeUserRole) && (
              <div className="sidebar-item" onClick={() => handleMenuClick('/userRoleList')}>
                <i className="bi bi-shield-fill me-2"></i>
                User Roles
              </div>
            )}
            
            {AppFunc.hasLocationAccess(activeUserRole) && (
              <div className="sidebar-item" onClick={() => handleMenuClick('/officeLocations')}>
                <i className="bi bi-geo-alt-fill me-2"></i>
                Office Locations
              </div>
            )}
            
            {AppFunc.hasApproveTimesheetAccess(activeUserRole) && (
              <div className="sidebar-section">
                <div className="sidebar-section-title">
                  <i className="bi bi-clock-fill me-2"></i>
                  Timesheets
                </div>
                <div className="sidebar-submenu">
                  <div className="sidebar-item sub-item" onClick={() => handleMenuClick('/approveTimesheet')}>
                    Approve Timesheets
                  </div>
                  <div className="sidebar-item sub-item" onClick={() => handleMenuClick('/timesheet')}>
                    Timesheets
                  </div>
                </div>
              </div>
            )}
            
            {AppFunc.hasImportTimesheetAccess(activeUserRole) && (
              <div className="sidebar-item" onClick={() => handleMenuClick('/importTimesheet')}>
                <i className="bi bi-file-earmark-text-fill me-2"></i>
                Import Timesheet
              </div>
            )}
            
            {AppFunc.hasReportAccess(activeUserRole) && (
              <div className="sidebar-section">
                <div className="sidebar-section-title">
                  <i className="bi bi-file-earmark-text-fill me-2"></i>
                  Reports
                </div>
                <div className="sidebar-submenu">
                  {activeUserRole !== APP_CONSTANTS.USER_ROLES.PROJECT_MANAGER && 
                   activeUserRole !== APP_CONSTANTS.USER_ROLES.OFF_SHORE_LEAD && (
                    <>
                      <div className="sidebar-item sub-item" onClick={() => handleMenuClick('/forecastHours')}>
                        Forecast Hours
                      </div>
                      <div className="sidebar-item sub-item" onClick={() => handleMenuClick('/availableHours')}>
                        Available Percentage
                      </div>
                    </>
                  )}
                  <div className="sidebar-item sub-item" onClick={() => handleMenuClick('/utilization')}>
                    Utilization Report
                  </div>
                  <div className="sidebar-item sub-item" onClick={() => handleMenuClick('/comprehensiveReports')}>
                    Comprehensive Reports
                  </div>
                </div>
              </div>
            )}
            
            {AppFunc.hasHiringAccess(activeUserRole) && (
              <div className="sidebar-section">
                <div className="sidebar-section-title">
                  <i className="bi bi-person-plus-fill me-2"></i>
                  Hiring Enquires
                </div>
                <div className="sidebar-submenu">
                  <div className="sidebar-item sub-item" onClick={() => handleMenuClick('/enquiredbyme')}>
                    By Me
                  </div>
                  <div className="sidebar-item sub-item" onClick={() => handleMenuClick('/enquiredtome')}>
                    To Me
                  </div>
                </div>
              </div>
            )}
            
            {AppFunc.hasAIChatAccess(activeUserRole) && (
              <div className="sidebar-item" onClick={() => handleMenuClick('/ichat')}>
                <i className="bi bi-chat-dots-fill me-2"></i>
                Explore Resumes
              </div>
            )}
            
            {AppFunc.hasAIChatAccess(activeUserRole) && (
              <div className="sidebar-item" onClick={() => handleMenuClick('/idb')}>
                <i className="bi bi-database-fill me-2"></i>
                Explore Database
              </div>
            )}
          </div>

          {/* Logout Section at Bottom */}
          
        </div>
    </>
)
}
export default Menu;
